module.exports = __webpack_public_path__ + "img/chevron-left-20px-light.af861ff.svg";